const isStaging = window.location.hostname.includes('staging');

export function StagingBanner() {
  if (!isStaging) return null;

  return (
    // In-flow layout row (not a fixed overlay): it occupies real height at the
    // top of Layout's h-screen column, so fixed overlays (task slide-over,
    // drawers) can never end up hidden underneath it (MKS-144 UAT 2026-08-12).
    <div className="shrink-0 bg-green-600 text-white px-4 py-2 flex items-center justify-center text-sm font-medium shadow-md">
      Staging Environment
    </div>
  );
}

export { isStaging };
